function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-3 -3)"
}, React.createElement("path", {
  d: "M0 0h16v16H0z"
}), React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 4.52,
  fill: "#D14B08"
}));

var SvgBulletShape2 = function SvgBulletShape2(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEwIDEwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMgLTMpIj4KICAgICAgICA8cGF0aCBkPSJNMCAwaDE2djE2SDB6Ii8+CiAgICAgICAgPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjQuNTIiIGZpbGw9IiNEMTRCMDgiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgBulletShape2 as ReactComponent };